import deepMerge from 'deepmerge';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var n=.2126,t=.7152,r=.0722,e=1/12.92;function u(n){return Math.pow((n+.055)/1.055,2.4)}function a(a){var i=a[0]/255,c=a[1]/255,o=a[2]/255,s=i<=.03928?i*e:u(i),f=c<=.03928?c*e:u(c),p=o<=.03928?o*e:u(o);return s*n+f*t+p*r}function c(n,t){return (Math.max(n,t)+.05)/(Math.min(n,t)+.05)}function o(n,t){return c(a(n),a(t))}

/**
 * Converts the given hex code to its RGB digits
 *
 * @param {string} hex - hex color code
 * @returns {number[]} RGB color numbers
 */

var hexToRGBArray = function hexToRGBArray(hex) {
  var truncated = hex.length < 7;
  return hex.substring(1).match(truncated ? /./g : /.{2}/g).map(function (value) {
    return truncated ? "".concat(value).concat(value) : value;
  }).map(function (value) {
    return parseInt(value, 16);
  });
};
/**
 * Converts the given color code to the array of RGB color numbers
 *
 * @param {string} color - hex or RGB color code
 * @returns {string[]} RGB color numbers
 */

var getRGBArray = function getRGBArray(color) {
  return color.startsWith('#') ? hexToRGBArray(color) : color.split(',').map(function (value) {
    var start = value.indexOf('(') + 1;
    var end = value.indexOf(')');
    return value.substring(start, end === -1 ? undefined : end).trim();
  });
};
/**
 * Converts the given color to RGBA with the provided opacity
 *
 * @param {string} color - hex, RGB, or RGBA color code
 * @param {number} opacity - opacity value in the range 0...1
 * @returns {string} RGBA color code
 */

var setOpacity = function setOpacity(color, opacity) {
  var rgbArray = getRGBArray(color);
  rgbArray[3] = opacity;
  return "rgba(".concat(rgbArray.join(', '), ")");
};
/**
 * Returns the most contrasting text color for the given background from the palette
 *
 * @param {Object} palette - The theme palette object
 * @param {string} background - The background color code
 * @returns {string} The most contrasting text color
 */

var getContrastText = function getContrastText(palette, background) {
  var rgb = getRGBArray(background);
  var darkContrast = o(rgb, getRGBArray(palette.text.dark));
  var lightContrast = o(rgb, getRGBArray(palette.text.light));
  return darkContrast > lightContrast ? palette.text.dark : palette.text.light;
};
/** Curried version of `getContrastText` */

var curriedContrastText = function curriedContrastText(palette) {
  return function (background) {
    return getContrastText(palette, background);
  };
};

var breakpoints = {
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  }
};

var basePalette = {
  background: '#FFFFFF',
  highlightBackground: '#F5F5F5',
  text: {
    dark: '#333333',
    midGray: '#6E6E6E',
    light: '#FFFFFF'
  },
  info: '#4C89C6',
  error: '#97030A',
  form: {
    error: '#F90000',
    border: '#CCCCCC'
  },
  primary: {
    light: '#E8F3FF',
    normal: '#0074BD',
    dark: '#369',
    veryDark: '#00558A',
    darkBackground: '#4C4C4C',
    disabled: '#A1C2E1',
    disabledAccent: undefined // not sure if this applies in legacy

  },
  outline: undefined,
  // not relevant
  accent: '#CCCCCC',
  money: {
    light: '#A6E400',
    normal: '#669933',
    dark: '#2F6300'
  },
  focus: {
    normal: '#20A2FF',
    dark: '#66BFFF'
  },
  grey: {
    G50: '#fafafa',
    G100: '#f5f5f5',
    G200: '#eeeeee',
    G300: '#e0e0e0',
    G400: '#bdbdbd',
    G500: '#9e9e9e',
    G600: '#757575',
    G700: '#616161',
    G800: '#424242',
    G900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161'
  },
  visualizations: ['#8ce6ff', '#00a0e1', '#64ebd7', '#a0d250', '#ff9c46', '#9f4fdc', '#44c8f5', '#00c8be', '#32c846', '#ffd250', '#dc6ee1', '#967aff']
};

var spacing = {
  unit: 8
};

var transitions = {
  easing: {
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
  },
  duration: {
    shortest: 150,
    shorter: 200,
    "short": 250,
    standard: 300,
    complex: 375,
    enteringScreen: 225,
    leavingScreen: 195
  }
};

var roboto = 'Roboto, Helvetica, Arial, sans-serif';
var light = 300;
var regular = 400;
var medium = 500;
var bold = 700;
var typography = {
  fontFamily: roboto,
  fontSize: 14,
  fontWeight: regular,
  fontWeightLight: light,
  fontWeightRegular: regular,
  fontWeightMedium: medium,
  fontWeightHeavy: bold,
  text: {
    fontFamily: roboto,
    fontSize: 16,
    fontWeight: regular
  },
  title: {
    fontFamily: roboto,
    fontSize: 20,
    fontWeight: regular
  },
  h2: {
    fontFamily: roboto,
    fontSize: 18,
    fontWeight: regular
  },
  h3: {
    fontFamily: roboto,
    fontSize: 16,
    fontWeight: regular
  },
  h4: {
    fontFamily: roboto,
    fontSize: 14,
    fontWeight: bold
  },
  h5: {
    fontFamily: roboto,
    fontSize: 14,
    fontWeight: medium
  },
  label: {
    fontFamily: roboto,
    fontSize: 13,
    fontWeight: bold
  }
};

var variantsFn = (function (_ref) {
  var palette = _ref.palette;
  return {
    primary: {
      light: palette.primary.light,
      normal: palette.primary.normal,
      dark: palette.primary.dark,
      contrastText: palette.text.light
    },
    secondary: {
      light: '#3f817f',
      normal: '#ccc',
      dark: '#2f615f',
      contrastText: palette.text.dark
    },
    success: {
      light: palette.money.light,
      normal: palette.money.normal,
      dark: palette.money.dark,
      contrastText: palette.text.light
    },
    positive: {
      light: palette.money.light,
      normal: palette.money.normal,
      dark: palette.money.dark,
      contrastText: palette.text.light
    },
    warning: {
      light: '#fff7d7',
      normal: '#ffc107',
      dark: '#fad335',
      contrastText: palette.text.light
    },
    info: {
      light: palette.info,
      normal: palette.info,
      dark: palette.info,
      contrastText: palette.text.light
    },
    error: {
      light: palette.error,
      normal: palette.error,
      dark: palette.error,
      contrastText: palette.text.light
    }
  };
});

var zIndex = {
  mobileStepper: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};

var legacyTheme = (function () {
  var inputTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var palette = inputTheme.palette ? deepMerge(basePalette, inputTheme.palette) : basePalette;
  var variants = variantsFn({
    palette: palette
  });
  var base = {
    palette: _objectSpread({}, palette, {
      variants: variants
    }),
    spacing: spacing,
    breakpoints: breakpoints,
    transitions: transitions,
    typography: typography,
    zIndex: zIndex
  };
  var merged = Object.keys(base).reduce(function (origin, key) {
    return _objectSpread({}, origin, _defineProperty({}, key, inputTheme[key] ? deepMerge(base[key], inputTheme[key]) : base[key]));
  }, base);
  merged.legacy = true;
  merged.name = 'legacy';
  merged.getContrastText = curriedContrastText(base.palette);
  return merged;
});

var colors = {
  alizarinCrimson: '#DC2828',
  anakiwa: '#ADE2FF',
  anakiwaDataVis: '#8CE6FF',
  apple: '#669933',
  astral: '#37939B',
  athensGray: '#EAEDF0',
  azure: '#336699',
  baliHai: '#80A1B6',
  blueStone: '#005A61',
  brightTurquoise: '#00DFEB',
  catskillWhite: '#F4F7FA',
  cerulean: '#00C0F0',
  conifer: '#A0D250',
  dodgerBlue: '#1FA2FF',
  doveGray: '#6E6E6E',
  dullLavender: '#98AEE7',
  eden: '#12475E',
  emerald: '#32C846',
  fiord: '#3B5263',
  flamingo: '#F15A24',
  funGreen: '#008228',
  gallery: '#EDEDED',
  green: '#2F6300',
  greenApple: '#669933',
  heliotrope: '#967AFF',
  hippieBlue: '#5491B1',
  lavender: '#DC6EE1',
  lime: '#A6E400',
  limedSpruce: '#3B464F',
  lochmara: '#0070B9',
  mediumPurple: '#9F4FDC',
  midnightBlue: '#003366',
  mineShaft: '#333333',
  monaLisa: '#FF9494',
  mustard: '#FFD250',
  nevada: '#646E77',
  pickledBluewood: '#37435C',
  pictonBlue: '#44C8F5',
  prussianBlue: '#003366',
  pumpkin: '#F15A24',
  red: '#DF0000',
  regentStBlue: '#A2C3E2',
  robinsEggBlue: '#00C8BE',
  rollingStone: '#808285',
  seagull: '#87CBEE',
  silver: '#CCCCCC',
  thunder: '#231F20',
  tundora: '#4C4C4C',
  turquoiseBlue: '#64EBD7',
  verdunGreen: '#2F6300',
  white: '#FFFFFF',
  wildBlueYonder: '#7B8AAD',
  yellowOrange: '#FF9C46'
};
var basePalette$1 = {
  background: colors.white,
  highlightBackground: colors.gallery,
  text: {
    dark: colors.mineShaft,
    midGray: colors.doveGray,
    midLight: colors.catskillWhite,
    light: colors.white
  },
  info: colors.brightTurquoise,
  error: colors.pumpkin,
  form: {
    error: colors.red,
    border: colors.silver
  },
  primary: {
    light: colors.dodgerBlue,
    normal: colors.lochmara,
    dark: colors.azure,
    veryDark: colors.prussianBlue,
    darkBackground: colors.pickledBluewood,
    disabled: colors.seagull,
    disabledAccent: colors.baliHai
  },
  outline: colors.astral,
  accent: colors.silver,
  focus: {
    normal: colors.dodgerBlue,
    dark: colors.dodgerBlue
  },
  money: {
    light: colors.lime,
    normal: colors.greenApple,
    dark: colors.green
  },
  grey: {
    // This object is deprecated. Reference colors directly. To be removed on the next major version
    G50: colors.catskillWhite,
    G100: colors.gallery,
    G200: colors.gallery,
    G300: colors.gallery,
    G400: colors.silver,
    G500: colors.silver,
    G600: colors.doveGray,
    G700: colors.doveGray,
    G800: colors.rollingStone,
    G900: colors.thunder,
    A100: colors.silver,
    A200: colors.silver,
    A400: colors.mineShaft,
    A700: colors.doveGray
  },
  visualizations: [colors.anakiwa, colors.cerulean, colors.turquoiseBlue, colors.conifer, colors.yellowOrange, colors.mediumPurple, colors.pictonBlue, colors.robinsEggBlue, colors.emerald, colors.mustard, colors.lavender, colors.heliotrope],
  dark: {
    form: {
      error: colors.red.monaLisa
    },
    background: colors.thunder
  },
  colors: colors
};

var spacing$1 = {
  unit: 8
};

var breakpoints$1 = {
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  }
};

var transitions$1 = {
  easing: {
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
  },
  duration: {
    shortest: 150,
    shorter: 200,
    "short": 250,
    standard: 300,
    complex: 375,
    enteringScreen: 225,
    leavingScreen: 195
  }
};

var roboto$1 = 'Roboto, Helvetica, Arial, sans-serif';
var barlowCondensed = "\"Barlow Condensed\", ".concat(roboto$1);
var robotoCondensed = "\"Roboto Condensed\", ".concat(roboto$1);
var light$1 = 300;
var regular$1 = 400;
var medium$1 = 500;
var bold$1 = 700;
var typographyFn = (function (_ref) {
  var palette = _ref.palette;
  return {
    fontFamily: roboto$1,
    fontSize: 16,
    fontWeight: regular$1,
    fontWeightLight: light$1,
    fontWeightRegular: regular$1,
    fontWeightMedium: medium$1,
    fontWeightHeavy: bold$1,
    text: {
      fontFamily: roboto$1,
      fontSize: 16,
      fontWeight: regular$1
    },
    title: {
      color: '#000',
      fontFamily: barlowCondensed,
      fontSize: 50,
      fontWeight: light$1
    },
    h2: {
      fontFamily: roboto$1,
      fontSize: 30,
      fontWeight: medium$1
    },
    h3: {
      fontFamily: robotoCondensed,
      fontSize: 20,
      fontWeight: regular$1,
      textTransform: 'uppercase'
    },
    h4: {
      fontFamily: roboto$1,
      fontSize: 20,
      fontWeight: medium$1
    },
    h5: {
      fontFamily: robotoCondensed,
      fontSize: 16,
      fontWeight: bold$1,
      textTransform: 'uppercase'
    },
    label: {
      color: palette.text.midGray,
      fontFamily: roboto$1,
      fontSize: 12,
      fontWeight: bold$1,
      textTransform: 'uppercase'
    }
  };
});

var variantsFn$1 = (function (_ref) {
  var palette = _ref.palette;
  return {
    primary: {
      light: palette.primary.light,
      normal: palette.primary.normal,
      dark: palette.primary.dark,
      contrastText: palette.text.light
    },
    secondary: {
      light: palette.colors.alizarinCrimson,
      normal: palette.colors.silver,
      dark: palette.colors.red,
      contrastText: palette.text.dark
    },
    success: {
      light: palette.money.light,
      normal: palette.money.normal,
      dark: palette.money.dark,
      contrastText: palette.text.light
    },
    positive: {
      light: palette.money.light,
      normal: palette.money.normal,
      dark: palette.money.dark,
      contrastText: palette.text.light
    },
    warning: {
      light: palette.colors.mustard,
      normal: palette.colors.yellowOrange,
      dark: palette.colors.mustard,
      contrastText: palette.text.light
    },
    info: {
      light: palette.info,
      normal: palette.info,
      dark: palette.info,
      contrastText: palette.text.light
    },
    error: {
      light: palette.error,
      normal: palette.error,
      dark: palette.error,
      contrastText: palette.text.light
    }
  };
});

var zIndex$1 = {
  mobileStepper: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};

var ashTheme = (function () {
  var inputTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var palette = inputTheme.palette ? deepMerge(basePalette$1, inputTheme.palette) : basePalette$1;
  var variants = variantsFn$1({
    palette: palette
  });
  var typography = typographyFn({
    palette: palette
  });
  var base = {
    palette: _objectSpread({}, palette, {
      variants: variants
    }),
    spacing: spacing$1,
    breakpoints: breakpoints$1,
    transitions: transitions$1,
    typography: typography,
    zIndex: zIndex$1
  };
  var merged = Object.keys(base).reduce(function (origin, key) {
    return _objectSpread({}, origin, _defineProperty({}, key, inputTheme[key] ? deepMerge(base[key], inputTheme[key]) : base[key]));
  }, base);
  merged.name = 'ash';
  merged.getContrastText = curriedContrastText(base.palette);
  return merged;
});

var moduleDefaults = {};
var moduleDependencies = {};
var moduleCallbacks = [];
var listenForRegisteredModules = function listenForRegisteredModules(callback) {
  moduleCallbacks.push(callback);
  return function () {
    moduleCallbacks = moduleCallbacks.filter(function (item) {
      return item !== callback;
    });
  };
};
/**
 * Sets the default theme attributes for a themed module
 *
 * @param {string} module - The unique name for a themed module
 * @param {Object|function} defaults - Object or function returning the default theme for the module
 * @param {string[]} [dependencies] - List of names for modules on which the current module depends
 */

var registerDefaultsForModule = function registerDefaultsForModule(module, defaults, dependencies) {
  if (moduleDefaults[module]) {
    window.console.warn("Default theme values for ".concat(module, " have already been registered"));
  }

  moduleDefaults[module] = defaults;

  if (dependencies) {
    moduleDependencies[module] = dependencies;
  }

  moduleCallbacks.forEach(function (callback) {
    return callback();
  });
};
var getModuleDefaults = function getModuleDefaults(baseTheme, theme) {
  var result = _objectSpread({}, baseTheme);

  var modules = _objectSpread({}, moduleDefaults); // this will loop over `modules` until all modules have been added to `result`


  for (var _Object$keys = Object.keys(modules), length = _Object$keys.length; length; _Object$keys2 = Object.keys(modules), length = _Object$keys2.length, _Object$keys2) {
    var _Object$keys2;

    Object.entries(modules).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      var dependencies = moduleDependencies[key] || []; // if all dependencies have been processed add the module and remove it from `modules`

      if (dependencies.filter(function (dep) {
        return !Object.keys(result).includes(dep);
      }).length === 0) {
        var moduleTheme = typeof value === 'function' ? value(result) : value;
        result[key] = theme && theme[key] ? deepMerge(moduleTheme, theme[key]) : moduleTheme;
        delete modules[key];
      }
    }); // if we've iterated over all the modules and none have satisfied dependencies something's wrong

    if (Object.keys(modules).length === length) {
      throw new Error("Circular or missing theme dependency detected in ".concat(Object.keys(modules).map(function (value) {
        return "`".concat(value, "`");
      }).join(', ')));
    }
  }

  return result;
};

var mergeTheme = function mergeTheme(baseTheme, theme) {
  return _objectSpread({}, theme, getModuleDefaults(baseTheme(theme), theme));
};

export { ashTheme, curriedContrastText, getContrastText, getModuleDefaults, getRGBArray, hexToRGBArray, legacyTheme, listenForRegisteredModules, mergeTheme, ashTheme as nextTheme, registerDefaultsForModule, setOpacity };
